export default __webpack_public_path__ + "static/media/Belt of the Lector.3b1807d2.jpg";